import { parse, format, parseISO } from 'date-fns';

const date = {
  // Formats a date to YYYY/MM/DD
  formatToDDMMYYYY: (value) => {
    return format(parseISO(value), 'dd/MM/yyyy');
  },
  // Formats a date from DD/MM/YYYY to YYYY/MM/DD
  formatToYYYYMMDD: (date) => {
    return format(parse(date, 'dd/MM/yyyy', new Date()), 'yyyy/MM/dd');
  },

  formatDateToDDMMYYYY(date) {
    // Extract day, month, and year from the Date object
    let day = date.getDate();
    let month = date.getMonth() + 1; // Month is zero-indexed, so we add 1
    let year = date.getFullYear();

    // Pad day and month with leading zeros if needed
    day = day < 10 ? '0' + day : day;
    month = month < 10 ? '0' + month : month;

    // Return the formatted date string
    return `${day}/${month}/${year}`;
},

  getDates(startDate, endDate) {
    let dates = [];
    let currentDate = new Date(startDate);
    endDate = new Date(endDate);

    while (currentDate <= endDate) {
        dates.push(new Date(currentDate));
        currentDate.setDate(currentDate.getDate() + 1);
    }

    return dates;
  }
};

export default date;
